var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightMEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "21px",
    viewBox: "0 0 65 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle Copy 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Company_Q2_M",
    transform: "translate(-257.000000, -78.000000)",
    fill: "#EEEEEE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-4",
    transform: "translate(54.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.595583,1.12568102 L266.097947,1.12568102 C266.650232,1.12568102 267.097947,1.57339627 267.097947,2.12568102 L267.097947,20.125681 C267.097947,20.6779658 266.650232,21.125681 266.097947,21.125681 L204.595583,21.125681 C204.043298,21.125681 203.595583,20.6779658 203.595583,20.125681 C203.595583,19.8522308 203.707563,19.5907089 203.905456,19.4019934 L211.825355,11.8493687 C212.225036,11.4682217 212.240062,10.835235 211.858915,10.4355534 C211.847995,10.4241028 211.836805,10.4129129 211.825355,10.4019934 L203.905456,2.84936868 C203.505774,2.46822171 203.490749,1.83523504 203.871896,1.43555338 C204.060611,1.23766082 204.322133,1.12568102 204.595583,1.12568102 Z",
    id: "Rectangle-Copy-10"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightMEmpty);
export default __webpack_public_path__ + "static/media/rightMEmpty.44463c707c816a24348c22d4b672508e.svg";
export { ForwardRef as ReactComponent };